"use strict";
exports.__esModule = true;
var transaction_converter_1 = require("@iota/transaction-converter");
var _1 = require("./");
/**
 * @method createReplayBundle
 *
 * @memberof module:core
 *
 * @param {Provider} provider - Network provider
 *
 * @return {Function} {@link #module_core.replayBundle `replayBundle`}
 */
exports.createReplayBundle = function (provider, attachFn) {
    var getBundle = _1.createGetBundle(provider);
    var sendTrytes = _1.createSendTrytes(provider, attachFn);
    /**
     * Reattaches a transfer to the Tangle by selecting tips and performing the Proof-of-Work again.
     * Reattachments are useful in case the original transactions are pending, and can be done securely
     * as many times as needed.
     *
     * @example
     * ```js
     * replayBundle(tail)
     *   .then(transactions => {
     *     // ...
     *   })
     *   .catch(err => {
     *     // ...
     *   })
     * })
     * ```
     *
     * @method replayBundle
     *
     * @memberof module:core
     *
     * @param {Hash} tail - Tail transaction hash. Tail transaction is the transaction in the bundle with
     * `currentIndex == 0`.
     *
     * @param {number} depth - The depth at which Random Walk starts. A value of `3` is typically used by wallets,
     * meaning that RW starts 3 milestones back.
     *
     * @param {number} minWeightMagnitude - Minimum number of trailing zeros in transaction hash. This is used by
     * [`attachToTangle`]{@link #module_core.attachToTangle} function to search for a valid `nonce`.
     * Currently it is `14` on mainnet & spamnet and `9` on most other testnets.
     *
     * @param {Callback} [callback] - Optional callback
     *
     * @returns {Promise}
     * @fulfil {Transaction[]}
     * @reject {Error}
     * - `INVALID_DEPTH`
     * - `INVALID_MIN_WEIGHT_MAGNITUDE`
     * - `INVALID_TRANSACTION_HASH`
     * - `INVALID_BUNDLE`
     * - Fetch error
     */
    return function replayBundle(tail, depth, minWeightMagnitude, reference, callback) {
        return getBundle(tail)
            .then(function (bundle) { return transaction_converter_1.asFinalTransactionTrytes(bundle); })
            .then(function (trytes) { return sendTrytes(trytes, depth, minWeightMagnitude, reference); })
            .asCallback(typeof arguments[3] === 'function' ? arguments[3] : callback);
    };
};
//# sourceMappingURL=createReplayBundle.js.map